import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_SERVER_IP;

export const registryApi = {
  getOrganizationDetails: async (authtoken, orgName) => {
    console.log('getOrganizationDetails', orgName);
    try {
      const response = await axios.get(`${BASE_URL}/api/registry/organization/${orgName}`, {
        headers: {
          authtoken
        }
      });
      console.log('getOrganizationDetails response', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch organization details', error);
      throw new Error('Failed to fetch organization details', error);
    }
  },

  migrateOrganizations: async (authtoken, migrationData) => {
    console.log('migrateOrganizations', migrationData);
    try {
      const response = await axios.post(
        `${BASE_URL}/api/registry/migrate-organizations`,
        migrationData,
        {
          headers: {
            authtoken
          }
        }
      );
      console.log('migrateOrganizations response', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to migrate organizations', error);
      throw new Error('Failed to migrate organizations');
    }
  }
};